module.exports = __webpack_public_path__ + "img/Aveda.4dbce364.png";